import { render, staticRenderFns } from "./ErrorMessages.vue?vue&type=template&id=2f12b055&scoped=true"
import script from "./ErrorMessages.vue?vue&type=script&lang=js"
export * from "./ErrorMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f12b055",
  null
  
)

export default component.exports